// extracted by mini-css-extract-plugin
module.exports = {"root":"root_1Wh3e","container":"container_242H_","headLine":"headLine_28uFn","text":"text_1sW8v"};